// const apiBase = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'https://virtserver.swaggerhub.com/zhaozhong/xxb_admin/1.0.0'
const apiBase = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'https://sr.xuanxingbao.com/bp'
const apiBase1 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/utdbg' : 'https://sr.xuanxingbao.com/utdbg'
const apiBase2 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/utdbg' : 'https://sr.xuanxingbao.com'
const apiBase3 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com' : 'http://sr.xuanxingbao.com'
// const apiBase = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'http://192.168.0.104:8080/XXB_PROJECT/bp'
// const apiBase2 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'http://192.168.0.104:8080/XXB_PROJECT'
// const apiBase = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'https://eapi.xuanxingbao.com/bp'
// const apiBase1 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'https://eapi.xuanxingbao.com/utdbg'
// const apiBase1 = process.env.NODE_ENV === 'production' ? 'https://sr.xuanxingbao.com/bp' : 'http://192.168.0.104:8080/XXB_PROJECT/utdbg'
exports.configs = {
  apiBase: apiBase,
  apiBase1: apiBase1,
  apiBase2: apiBase2,
  qiniuBucketUrl: 'https://img.xuanxingbao.com/',
  CONSTS: {
    pageSize: 20,
    defaultAvatar: '/static/img/avatar-bg.png'
  },
  STATUS: {
    ALL: 'ALL',
    PUBLISHED: 'PUBLISHED',
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    TRASHED: 'TRASHED',
    REJECTED: 'REJECTED',
    CLOSED: 'CLOSED',
    SCHEDULED: 'SCHEDULED',
    DELETED: 'DELETED',
    DESTROY: 'DESTROY'
  },
  TEXT: {
    footer: '选型宝 © 2020',
    footer_version: '1.0.0',
    common: {
      trash: {
        title: '删除',
        body: '确定删除该条内容?',
        success: '删除成功!',
        canceled: '已取消删除'
      },
      batch_trash: {
        title: '批量删除',
        body: '确定删除这些内容?',
        success: '删除成功!',
        canceled: '已取消删除'
      },
      confirm: '确定',
      cancel: '取消'
    },
    tag: {
      trashBody: '执行此操作后，数据将被彻底删除且不可被找回'
    },
    cancel: '操作已取消',
    success: '操作已成功'
  },
  MODULES: {
    'reviews': {
      id: 'reviews',
      title: '点评管理',
      icon: 'fa fa-comment',
      disabled: true,
      status: [
        { name: 'pending', label: '点评中的基础数据入库' },
        { name: 'stored', label: '点评审核' },
        { name: 'analysis', label: '点评智能分析处理' }
      ]
    },
    'enterprise': {
      id: 'enterprise',
      title: '企业账号管理',
      icon: 'fa fa-user-circle',
      disabled: true,
      status: [
        { name: 'enterprise', label: '企业账号管理' }
      ]
    },
    'meeting': {
      id: 'meeting',
      title: '会议频道管理',
      icon: 'fa fa-comment',
      disabled: true,
      status: [
        { name: 'meeting', label: '会议频道管理' }
      ]
    },
    'proceeds': {
      id: 'proceeds',
      title: '收款管理',
      icon: 'fa fa-envelope',
      disabled: true
    },
    'document': {
      id: 'document',
      title: '发布文档',
      icon: 'fa fa-file-text',
      disabled: true
    },
    'video': {
      id: 'video',
      title: '发布视频',
      icon: 'fa fa-file-video-o',
      disabled: true
    },
    'news': {
      id: 'news',
      title: '发布新闻',
      icon: 'fa fa-newspaper-o',
      disabled: true,
      status: [
        { name: 'sign', label: '签约新闻标签' },
        { name: 'share', label: '新闻分享' }
      ]
    },
    'index': {
      id: 'mpindex',
      title: '首页管理',
      icon: 'fa fa-home',
      disabled: false
    }
  },
  API: {
    login: `${apiBase}/user/login`,
    logout: `${apiBase}/user/logout`,
    // 数字化转型
    news: {
      list: `${apiBase3}/szhzx/news/list`,
      add: `${apiBase3}/szhzx/news/modify`,
      search: `${apiBase3}/szhzx/news/list`,
      detail: `${apiBase3}/szhzx/news/detail`,
      delete: `${apiBase3}/szhzx/news/delete`,
      sort: `${apiBase3}/szhzx/news/ordernum`,
      setHot: `${apiBase3}/szhzx/news/ishot`
    },
    files: {
      list: `${apiBase3}/szhzx/file/list`,
      add: `${apiBase3}/szhzx/file/modify`,
      search: `${apiBase3}/szhzx/file/list`,
      detail: `${apiBase3}/szhzx/file/detail`,
      delete: `${apiBase3}/szhzx/file/delete`
    },
    topuser: {
      list: `${apiBase3}/szhzx/topuser/list`,
      add: `${apiBase3}/szhzx/topuser/modify`,
      search: `${apiBase3}/szhzx/topuser/list`,
      detail: `${apiBase3}/szhzx/topuser/detail`,
      delete: `${apiBase3}/szhzx/topuser/delete`,
      sort: `${apiBase3}/szhzx/topuser/ordernum`
    },
    tags: {
      industry: {
        list: `${apiBase3}/szhzx/industry/list`,
        add: `${apiBase3}/szhzx/industry/modify`,
        delete: `${apiBase3}/szhzx/industry/delete`
      },
      domain: {
        list: `${apiBase3}/szhzx/demain/list`,
        add: `${apiBase3}/szhzx/demain/modify`,
        delete: `${apiBase3}/szhzx/demain/delete`
      }
    },
    reviews: {
      commentMoney: `${apiBase1}/category/recommend/comments`,
      listStored: `${apiBase}/review/list/achieved`,
      listPending: `${apiBase}/review/list/pending`,
      fillAndCheck: `${apiBase}/review/fill_and_check`,
      detail: `${apiBase}/review/detail`,
      replace: `${apiBase}/review/replace`,
      modify: `${apiBase}/review/modify`,
      createEntityByOneClick: `${apiBase}/review/create_entity_by_one_click`,
      update: `${apiBase}/review/detail/modify`,
      capacityList: `${apiBase}/review/list/handle`, // 列表
      // 默认选项
      capacitySelect: `${apiBase1}/default/score/keys`,
      // 添加有点关联关系 缺点关联关系
      capacityAdd: `${apiBase1}/score/dimension/function/relation`,
      // 根据类别id查询所有功能
      capacityFind: `${apiBase1}/auto/function/list`,
      // 所有维度列表接口
      acapacityAlList: `${apiBase1}/dimension/list`,
      // 智能分析详情
      AlListDetail: `${apiBase1}/default/score/keys`
    },
    // 获取七牛云
    getQiniuToken: {
      url: 'https://api.xuanxingbao.com/api/v1/token',
      method: 'post'
    },
    // 企业账号
    enterprise: {
      account: `${apiBase}/back/enterprise/account`,
      // 邮件通知状态
      status: `${apiBase}/back/account/isendemail `,
      // 原厂确认状态
      company: `${apiBase}/back/account/isoriginalfactory`,
      // 推荐确认状态
      recommend: `${apiBase}/back/account/isrecommend`,
      // 账户质量
      quality: `${apiBase}/back/account/qualitystatus`,
      // 是否推广
      extension: `${apiBase}/back/account/isextension`,
      jump: `${apiBase}/back/account/is_jump`
    },

    // 收款管理
    proceeds: {
      makecollections: `${apiBase}/back/enterprise/makecollections`,
      status: `${apiBase}/back/makecollections/update`
    },
    mpIndex: {
      getCategory: `${apiBase}/obtain/back/category`,
      update: `${apiBase}/back/homecategory`,
      getIndex: `${apiBase.replace('bp', '')}/sr/obtain/home/category`
    },
    autoComplete: {
      category: `${apiBase}/auto_complete/category`,
      product: `${apiBase}/auto_complete/product`,
      companyAlias: `${apiBase}/auto_complete/company_alias`,
      companyFullName: `${apiBase}/auto_complete/company_full_name`
    },
    // 会议
    meeting: {
      // 会议列表
      list: `${apiBase}/backg/broadcast`,
      // 会议推荐
      recommend: `${apiBase}/meeting/isrecommend`
    },
    sales: {
      // 未下载列表
      listNew: {
        url: `${apiBase}/zl/sales/leads`
      },
      // 已下载列表
      listDownloaded: {
        url: `${apiBase}/zl/already/sales/leads`
      },
      // 未下载详情
      listNewByAccount: `${apiBase}/zl/sales/leads/info`,
      // 已下载详情
      listByAccount: `${apiBase}/zl/already/sales/leads/info`,
      // 未下载
      downloadNewByAccount: `${apiBase}/zl/sales/leads/down`,
      // 已下载
      downloadByAccount: `${apiBase}/zl/already/sales/leads/down`,
      // 删除详情
      deleteByAccount: `${apiBase}/back/sales/leads/delete`
    },
    // 厂商管理
    company: {
      // 厂商详情
      detail: `${apiBase1}/factoryqc/info`,
      // 厂商修改
      edit: `${apiBase1}/factoryqc/update`,
      // 厂商列表
      list: `${apiBase1}/factoryqc/list`,
      // 新增
      add: `${apiBase1}/factoryqc/add`,
      // 删除
      del: `${apiBase1}/factoryqc/delete`,
      // 简称添加
      shortAdd: `${apiBase1}/factory/add`,
      // 简称删除
      shortDel: `${apiBase1}/factory/delete`

    },
    // 补全搜索
    auto: {
      // 类别
      category: `${apiBase}/auto_complete/category`,
      // 全称
      full: `${apiBase}/auto_complete/company_full_name`,
      // 简称
      alias: `${apiBase}/auto_complete/company_alias`,
      // 全称、简称
      product: `${apiBase}/auto_complete/product`

    },
    // 类别
    category: {
      // 列表
      list: `${apiBase1}/category/list`,
      // 类别接口修改
      edit: `${apiBase1}/category/navigation/edit`,
      // 获取类别详情
      getDetial: `${apiBase1}/category/info`,
      // 修改类别详情
      editDetial: `${apiBase1}/category/navigation/edit`,
      // 新增类别详情
      addDetial: `${apiBase1}/category/add`,
      // 删除类别详情
      delDetial: `${apiBase1}/category/delete`
    },
    // 功能
    // 功能类别
    funC: {
      // 列表
      list: `${apiBase1}/functiontype/list`,
      // 添加
      add: `${apiBase1}/functiontype/add`,
      // 删除
      del: `${apiBase1}/functiontype/dele`
    },
    // 功能清单管理
    funM: {
      // 列表
      list: `${apiBase1}/function/list`,
      // 添加
      add: `${apiBase1}/function/add`,
      // 删除
      del: `${apiBase1}/function/dele`,
      // 编辑
      edit: `${apiBase1}/function/edit`
    },
    // 功能关键词
    funK: {
      // 列表
      list: `${apiBase1}/functionkeyword/list`,
      // 添加
      add: `${apiBase1}/functionkeyword/add`,
      // 删除
      del: `${apiBase1}/functionkeyword/dele`
    },
    // 大类
    class: {
      // 列表
      list: `${apiBase1}/navigation/list`,
      // 添加
      add: `${apiBase1}/navigation/add`,
      // 删除
      del: `${apiBase1}/navigation/delete`
    },
    // 产品管理
    product: {
      // 产品列表
      list: `${apiBase1}/product/list`,
      // 添加产品
      add: `${apiBase1}/product/add`,
      // 删除产品
      del: `${apiBase1}/product/delete`,
      // 产品修改
      edit: `${apiBase1}/product/edit`,
      // 列表详情
      detail: `${apiBase1}/product/info`
    },
    // 添加类别与产品关联关系
    cate: {
      // 添加产品
      add: `${apiBase1}/product/category/add`,
      // 删除产品
      del: `${apiBase1}/product/category/delete`
    },
    // 马上打钱
    getMoney: {
      // 添加产品
      add: `https://sr.xuanxingbao.com/comments-pay/withdrawals`
    },
    // 维度分类
    analysis: {
      // 维度分类管理
      dimensiontype: {
        // 添加维度分类
        add: `${apiBase1}/dimensiontype/add`,
        // 删除维度分类
        del: `${apiBase1}/dimensiontype/dele`,
        // 维度分类列表
        list: `${apiBase1}/dimensiontype/list`
      },
      // 维度管理
      dimension: {
        // 添加维度分类
        add: `${apiBase1}/dimension/add`,
        // 删除维度分类
        del: `${apiBase1}/dimension/dele`,
        // 维度分类列表
        list: `${apiBase1}/dimension/list`,
        // 维度编辑
        edit: `${apiBase1}/dimension/edit`
      },
      // 关键词管理
      keyword: {
        // 添加维度分类
        add: `${apiBase1}/dimensionkeyword/add`,
        // 删除维度分类
        del: `${apiBase1}/dimensionkeyword/dele`,
        // 维度分类列表
        list: `${apiBase1}/dimensionkeyword/list`
      }
    },
    mp: {
      update: {
        url: `${apiBase}/back/account/refresh`,
        method: 'post'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/configs.js